
export const enum TABLE_COLUMN_KEY {
  Gear = 'gear',
  Id = 'id',
  SymbolKey = 'symbolKey',
};
export const STATIC_TABLE_COLUMN_KEYS: string[] = [TABLE_COLUMN_KEY.SymbolKey, TABLE_COLUMN_KEY.Gear];
export const IDENTIFIER_TABLE_COLUMN_KEYS: string[] = [TABLE_COLUMN_KEY.SymbolKey, TABLE_COLUMN_KEY.Gear, TABLE_COLUMN_KEY.Id];
